import React, {FC, useEffect, useState} from 'react'
import {useParams} from 'react-router'
import PageContainer from '@components/UI/PageContainer/PageContainer'
import EditStory from './EditStory/EditStory'

const StoryEditorPage: FC = () => {
  const {uid} = useParams<{uid: string}>()

  const [curUid, setCurUid] = useState(uid)

  useEffect(() => {
    setCurUid(uid)
  }, [uid])

  return (
    <PageContainer>
      <EditStory uid={curUid} />
    </PageContainer>
  )
}

export default StoryEditorPage
